export default __webpack_public_path__ + "static/media/Blue.e25b4e2e.gif";